import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Env } from '../env';
import { BankListItem } from '../models/bankListItem';
import { Observable } from 'rxjs';
import { Bank } from '../models/bank';
import { EvaluationListItem } from '../models/evaluationListItem';
import { environment } from '../../environments/environment';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize } from 'rxjs/operators';
import { Evaluation } from '../models/evaluation';
import { EvaluationListItemSource } from '../models/evaluationListItemSource';
import { EvaluationSource } from '../models/evaluationSource';



@Injectable()
export class EvaluationService {

  constructor( 
    private http: HttpClient, 
    private global: Env,
  ) { }

  getAll( page:number = 0 , code:string = "" , dni:string = "" , ruc:string = "", status:string = "" , size:number = 10): Observable<EvaluationListItemSource[]> {
    let filtro= "";
    if ( code > "" ){
      filtro += "&code="+code;
    }
    if ( dni > "" ) {
      filtro += "&dni="+dni;
    }
    
    if ( ruc > "" ) {
      filtro += "&ruc="+ruc;
    }

    if ( status > "" ){
      filtro += "&status="+status;
    }
    
    const url = this.global.evaluation+'?page='+page+filtro+'&size='+size;
    console.log(url);
    return this.http.get(url).map( (res:EvaluationListItemSource[]) => {
      return res;
    });
  }
  
  get( id ): Observable<EvaluationSource> {
    const url = this.global.evaluation + '/' + id;
    return this.http.get(url).map( (res:EvaluationSource) => {
      return res;
    });
  }

  rechazar(id,sus): Observable<any> {
    const url = this.global.evaluation + '/' + id;
    return this.http.post(url, { observation: sus , status: 'I' }).map((res:any) => {
      return res;
    });
  }

  aprobar(id,sus): Observable<any> {
    const url = this.global.evaluation + '/' + id;
    //console.log(url);
    return this.http.post(url, { observation: ( sus > "" ? sus : null ) , status: 'S' }).map((res:any) => {
      return res;
    });
  }

  

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/evaluation.service.ts